import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { staffChangePassword, formatErr } from "@/lib/staffApi";
import { useStaff } from "@/pages/staff/StaffApp";
import { Loader2 } from "lucide-react";

export default function StaffChangePassword() {
  const { user, refresh, loading: authLoading } = useStaff();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (!authLoading && !user) {
    navigate("/staff/login");
  }

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await staffChangePassword(current, next);
      await refresh();
      navigate(user?.role === "mantenimiento" ? "/staff/admin" : "/staff/bandeja");
    } catch (e2) {
      setErr(formatErr(e2.response?.data?.detail) || e2.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-neutral-100 flex items-center justify-center p-4">
      <form onSubmit={submit} data-testid="staff-changepw-form"
        className="w-full max-w-md bg-[#111] border border-neutral-800 rounded-2xl p-7 space-y-5">
        <div>
          <div className="text-lg font-bold">Cambia tu contraseña</div>
          <div className="text-sm text-neutral-500">Primer acceso: define una contraseña nueva (mínimo 10 caracteres).</div>
        </div>
        <div>
          <label className="text-xs text-neutral-400">Contraseña actual (temporal)</label>
          <input type="password" required value={current} onChange={(e) => setCurrent(e.target.value)}
            data-testid="staff-changepw-current"
            className="mt-1 w-full bg-[#0a0a0a] border border-neutral-700 rounded-lg px-3 py-2.5 text-sm focus:border-orange-500 outline-none" />
        </div>
        <div>
          <label className="text-xs text-neutral-400">Nueva contraseña</label>
          <input type="password" required value={next} onChange={(e) => setNext(e.target.value)}
            data-testid="staff-changepw-new"
            className="mt-1 w-full bg-[#0a0a0a] border border-neutral-700 rounded-lg px-3 py-2.5 text-sm focus:border-orange-500 outline-none" />
        </div>
        {err && <div className="text-sm text-red-400" data-testid="staff-changepw-error">{err}</div>}
        <button type="submit" disabled={loading} data-testid="staff-changepw-submit"
          className="w-full bg-orange-500 hover:bg-orange-600 disabled:opacity-60 text-black font-semibold rounded-lg py-2.5 flex items-center justify-center gap-2">
          {loading && <Loader2 size={16} className="animate-spin" />} Guardar y continuar
        </button>
      </form>
    </div>
  );
}
